import React from "react";

export const TEMPLATE_PENDING_TEXT = "Template is being prepared";

interface Props {
  cypressId?: string;
  className?: string;
}

// Shown in place of a template, rules or preview link whose file the API has not generated yet.
export const TemplatePendingNote: React.FC<Props> = ({ cypressId = "templatePendingNote", className }) => (
  <span className={className} data-cypress-id={cypressId} style={{ color: "#707087", fontSize: 12 }}>
    {TEMPLATE_PENDING_TEXT}
  </span>
);
